/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import config from 'loracfg';


const defaultProps = {
  if: false,
};

const propTypes = {
  children: React.PropTypes.node.isRequired,
  if: React.PropTypes.oneOfType([
    React.PropTypes.bool,
    React.PropTypes.func,
    React.PropTypes.string,
  ]),
};

class ShowIf extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      if: props.if,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { if: ifCond } = nextProps;
    if (ifCond !== this.props.if) {
      this.setState({ if: ifCond });
    }
  }

  shouldShow() {
    const { if: ifCond } = this.state;
    if (_.isString(ifCond)) {
      const [key, value] = ifCond.split(':').map(s => (s.trim()));
      if (key === 'profile' && config.profile === value) {
        return true;
      }
    } else if (_.isFunction(ifCond)) {
      return ifCond();
    } else {
      return ifCond;
    }
    return false;
  }

  render() {
    if (this.shouldShow()) {
      return this.props.children;
    }
    return null;
  }
}

ShowIf.defaultProps = defaultProps;
ShowIf.propTypes = propTypes;

export default ShowIf;





// WEBPACK FOOTER //
// ./src/components/ShowIf/index.js